import { QueryGroup, QueryItem } from "../@types";
import { FLOW_STATES } from "../consts";

const formatCurrentMultiValue = (
  item: QueryItem,
  index: number,
  array: readonly QueryItem[],
  isLast?: boolean
) =>
  `${item.value}${
    isLast ||
    item.value === "]" ||
    (index === array.length - 2 && array[array.length - 1].value === "]")
      ? ""
      : ","
  }`;

export const getLabelFromQueryItems = (query: readonly QueryItem[]) =>
  query
    .map((item, index, array) => {
      const isLast = index === array.length - 1;
      switch (item.state) {
        case FLOW_STATES.ALL_KEYWORDS:
          return item.value;
        case FLOW_STATES.MULTI_VALUE:
          return formatCurrentMultiValue(item, index, array, isLast);
        case FLOW_STATES.FIRST_MULTI_VALUE:
          if (array[index + 1]?.value.toUpperCase() === "TO")
            return `${item.value} `;
          return formatCurrentMultiValue(item, index, array, isLast);
        case FLOW_STATES.MULTI_VALUE_OR_RANGE:
          if (item.value.toUpperCase() === "TO") return "TO ";
          return formatCurrentMultiValue(item, index, array, isLast);
        default:
          return item.value;
      }
    })
    .join("");

export const getLabelFromQueryGroups = (query: readonly QueryGroup[]) =>
  query
    .map(item => getLabelFromQueryItems(item.grouped ?? []))
    .join(" ")
    .replace("( ", "(")
    .replace(" )", ")");
